import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CleanupMock } from "../../../components/Mockups/CleanupMock";

export const Cleanup = () => {
  const { t } = useTranslation();
  return (
    <section id="cleanup" className="container section-padding pb-0">
      <div className="row align-items-center">
        <div className="col-xl-6 col-lg-6 col-12 order-1 order-lg-1">
          <div className="me-0 me-lg-4">
            <h3 className="mb-2 fs-2 fw-bold mb-4">
              {t("featurePages.cleanup.hero.title")}
            </h3>
            <div className="mb-3">
              <div className="d-flex align-items-center gap-2 mb-2">
                <i className="bi bi-magic fs-3 text-info"></i>
                <h4 className="fs-4 mb-0 fw-semibold">
                  {t("featurePages.cleanup.solution.benefit1.title")}
                </h4>
              </div>
              <p className="mb-0">
                {t("featurePages.cleanup.solution.benefit1.description")}
              </p>
            </div>
            <div className="mb-3 mb-4">
              <div className="d-flex align-items-center gap-3 mb-2">
                <i className="bi bi-clock-history fs-3 text-info"></i>
                <h4 className="fs-4 mb-0 fw-semibold">
                  {t("featurePages.cleanup.solution.benefit2.title")}
                </h4>
              </div>
              <p className="mb-0">
                {t("featurePages.cleanup.solution.benefit2.description")}
              </p>
            </div>
            <div className="mb-4">
              <Link
                to="/features/cleanup"
                className="btn btn-none text-info p-0 d-inline-flex align-items-center gap-2"
              >
                {t("features.buttons.cleanup")}
              </Link>
            </div>
          </div>
        </div>
        <div className="col-xl-6 col-lg-6 col-12 order-2 order-lg-2">
          <div className="bg-info-subtle p-3 p-md-4 rounded-4 d-flex justify-content-center ms-0 ms-lg-4">
            <CleanupMock />
          </div>
        </div>
      </div>
    </section>
  );
};
